import { ODataSelect } from "@iconics/core";

export class Tenancy extends ODataSelect
{
    public TenancyId = "";
    public Name = "";
    public IsEnabled = "";
    public DisplayName = "";
    public "@odata.etag" = "";

    override toSelect(): string
    {
        return ''
    }
}
